import dayjs from './DayjsUtil'

/**
 * Determina si una tarea esta por vencer (menos de 15 dias para su fecha de termino).
 */
export const esTareaPorVencer = (fechaTermino: string) => {
  return dayjs(fechaTermino).diff(new Date(), 'day') < 15
}
